import React from "react";
import { FormattedMessage } from "../../../../util/reactIntl";
import { CollapseFAQ, H1, NamedLink } from "../../../../components";

import css from './SitterPlans.module.css';
import ContinueIcon from '../../images/continue-icon.svg';
import { formatCurrencyMajorUnit } from "../../../../util/currency";
import { subscriptionTypes } from "../../../../util/subscriptionsHelpers";
import SectionCoupon from "../SectionCoupon/SectionCoupon";
import TrustWidgetBig from "../../../../components/StaticPageContainers/TrustWidgetBig";

const SitterPlans = props => {

    const { subscriptionPrices, createSubscription, intl, coupon,
        couponError,
        handleChange,
        promoCode,
        isBusy,
        onApplyCoupon,
    } = props;

    // first filter out the ones without nickname
    const subscriptionPricesNew = subscriptionPrices?.filter(p => p.nickname);

    const premiumSubscription = subscriptionPricesNew?.find(p => p.nickname.includes(subscriptionTypes.premium));
    const choiceSubscription = subscriptionPricesNew?.find(p => p.nickname.includes(subscriptionTypes.choice));
    const valueSubscription = subscriptionPricesNew?.find(p => p.nickname.includes(subscriptionTypes.value));

    const premiumSubscriptionFormattedPrice = premiumSubscription &&
        formatCurrencyMajorUnit(intl, premiumSubscription.currency.toUpperCase(), premiumSubscription.unit_amount / 100);
    const premiumSubscriptionFormattedPriceWithCoupon = coupon && premiumSubscription &&
        formatCurrencyMajorUnit(intl, premiumSubscription.currency.toUpperCase(), (premiumSubscription.unit_amount - (premiumSubscription.unit_amount * coupon.percent_off) / 100) / 100);

    const choiceSubscriptionFormattedPrice = choiceSubscription &&
        formatCurrencyMajorUnit(intl, choiceSubscription.currency.toUpperCase(), choiceSubscription.unit_amount / 100);
    const choiceSubscriptionFormattedPriceWithCoupon = coupon && choiceSubscription &&
        formatCurrencyMajorUnit(intl, choiceSubscription.currency.toUpperCase(), (choiceSubscription.unit_amount - (choiceSubscription.unit_amount * coupon.percent_off) / 100) / 100);

    const valueSubscriptionFormattedPrice = valueSubscription &&
        formatCurrencyMajorUnit(intl, valueSubscription.currency.toUpperCase(), valueSubscription.unit_amount / 100);
    const valueSubscriptionFormattedPriceWithCoupon = coupon && valueSubscription &&
        formatCurrencyMajorUnit(intl, valueSubscription.currency.toUpperCase(), (valueSubscription.unit_amount - (valueSubscription.unit_amount * coupon.percent_off) / 100) / 100);

    const scrollToCompare = (e) => {
        e.preventDefault();
        const compareSection = document.getElementById('compare');
        if (compareSection) {
            compareSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const faqs = [
        {
            question: <FormattedMessage id="MembershipPlansPage.sitter.faq1Question" />,
            answer: <FormattedMessage id="MembershipPlansPage.sitter.faq1Answer" />,
        },
        {
            question: <FormattedMessage id="MembershipPlansPage.sitter.faq2Question" />,
            answer: <FormattedMessage id="MembershipPlansPage.sitter.faq2Answer" />,
        },
        {
            question: <FormattedMessage id="MembershipPlansPage.sitter.faq3Question" />,
            answer: <FormattedMessage id="MembershipPlansPage.sitter.faq3Answer" />,
        },
        {
            question: <FormattedMessage id="MembershipPlansPage.sitter.faq4Question" />,
            answer: <FormattedMessage id="MembershipPlansPage.sitter.faq4Answer" />,
        },
        {
            question: <FormattedMessage id="MembershipPlansPage.sitter.faq5Question" />,
            answer: <FormattedMessage id="MembershipPlansPage.sitter.faq5Answer" />,
        },
        {
            question: <FormattedMessage id="MembershipPlansPage.sitter.faq6Question" />,
            answer: <FormattedMessage id="MembershipPlansPage.sitter.faq6Answer" />,
        },
    ];

    return (
        <div>

            <div className={css.introSection}>
                <div className={css.containerHero}>
                    <h1 className={css.title}>
                        <FormattedMessage id="MembershipPlansPage.sitter.heading" />
                    </h1>
                    <p className={css.subtitle}>
                        <FormattedMessage id="MembershipPlansPage.sitter.subheading" />
                    </p>

                    <h3 className={css.whatYouGetTitle}>
                        <FormattedMessage id="MembershipPlansPage.sitter.whatYouGetTitle" />
                    </h3>

                    <div className={css.whatYouGetGrid}>
                        <div className={css.whatYouGetItem}>
                            <div className={css.featureIcon}>🏡🐾</div>
                            <FormattedMessage id="MembershipPlansPage.sitter.whatYouGet1" />
                        </div>
                        <div className={css.whatYouGetItem}>
                            <div className={css.featureIcon}>🔒💬</div>
                            <FormattedMessage id="MembershipPlansPage.sitter.whatYouGet2" />
                        </div>
                        <div className={css.whatYouGetItem}>
                            <div className={css.featureIcon}>⭐👤</div>
                            <FormattedMessage id="MembershipPlansPage.sitter.whatYouGet3" />
                        </div>
                        <div className={css.whatYouGetItem}>
                            <div className={css.featureIcon}>🐾📞</div>
                            <FormattedMessage id="MembershipPlansPage.sitter.whatYouGet4" />
                        </div>
                    </div>

                    <div className={css.introActions}>
                        <button onClick={scrollToCompare} className={css.compareAnchorButton}>
                            <FormattedMessage id="MembershipPlansPage.sitter.compareButton" />
                        </button>
                        <p className={css.helperText}>
                            <FormattedMessage id="MembershipPlansPage.sitter.helperText" /> •{' '}
                            <NamedLink name="WhatIsHouseSittingPage" className={css.helperLink}>
                                <FormattedMessage id="MembershipPlansPage.sitter.helperLink" />
                            </NamedLink>
                        </p>
                    </div>
                </div>
            </div>

            <div className={css.root}>

                {/* Compare Features Section */}
                <div id="compare" className={css.compareSection}>
                    <h2 className={css.compareSectionTitle}>
                        <FormattedMessage id="MembershipPlansPage.sitter.compareTitle" />
                    </h2>
                    <p className={css.compareSectionSubtitle}>
                        <FormattedMessage id="MembershipPlansPage.sitter.compareSubtitle" />
                    </p>

                    <div className={css.compareTable}>
                        <table className={css.table}>
                            <thead>
                                <tr>
                                    <th>Feature</th>
                                    <th>Value</th>
                                    <th className={css.popularColumn}>Choice<br /><span className={css.popularBadge}>Most popular</span></th>
                                    <th>Premium</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><FormattedMessage id="MembershipPlansPage.sitter.compareFeature1" /></td>
                                    <td>—</td>
                                    <td>—</td>
                                    <td className={css.included}>✓</td>
                                </tr>
                                <tr>
                                    <td><FormattedMessage id="MembershipPlansPage.sitter.compareFeature2" /></td>
                                    <td>—</td>
                                    <td className={css.included}>✓</td>
                                    <td className={css.included}>✓</td>
                                </tr>
                                <tr>
                                    <td><FormattedMessage id="MembershipPlansPage.sitter.compareFeature3" /></td>
                                    <td>—</td>
                                    <td className={css.included}>✓</td>
                                    <td className={css.included}>✓</td>
                                </tr>
                                <tr>
                                    <td><FormattedMessage id="MembershipPlansPage.sitter.compareFeature4" /></td>
                                    <td className={css.included}>✓</td>
                                    <td className={css.included}>✓</td>
                                    <td className={css.included}>✓</td>
                                </tr>
                                <tr>
                                    <td><FormattedMessage id="MembershipPlansPage.sitter.compareFeature5" /></td>
                                    <td className={css.included}>✓</td>
                                    <td className={css.included}>✓</td>
                                    <td className={css.included}>✓</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <p className={css.compareFootnote}>
                        <FormattedMessage id="MembershipPlansPage.sitter.compareFootnote" />
                    </p>
                </div>

                {/* Plan Cards Section */}
                <div className={css.plansContainer}>
                    <div className={css.plansHeading}>
                        <h2>House Sitter Membership Options</h2>
                    </div>

                    <div className={css.container}>
                        {/* Value Plan */}
                        <div className={css.card}>
                            <div className={css.cardTitle}>
                                Value Match
                            </div>

                            <div className={css.planDescription}>
                                <p><strong><FormattedMessage id="MembershipPlansPage.sitter.valueBestFor" /></strong></p>
                                <p><FormattedMessage id="MembershipPlansPage.sitter.valueYouGet" /></p>
                                <p><FormattedMessage id="MembershipPlansPage.sitter.valuePerks" /></p>
                            </div>

                            <div>
                                <div className={coupon ? css.cardPriceDiscounted : css.cardPrice}>
                                    <span className={css.price}>
                                        {valueSubscriptionFormattedPrice}
                                    </span>
                                    per year
                                </div>
                                {coupon &&
                                    <div className={css.cardPrice}>
                                        <span className={css.price}>
                                            {valueSubscriptionFormattedPriceWithCoupon}
                                        </span>
                                        per first year
                                    </div>
                                }
                            </div>

                            <div className={css.button}
                                onClick={() => createSubscription(valueSubscription.id)}>
                                Continue with Value
                                <img className={css.icon} src={ContinueIcon} />
                            </div>
                        </div>

                        {/* Choice Plan - Most Popular */}
                        <div className={css.cardOffest}>
                            <div className={css.tag}>
                                Most popular
                            </div>
                            <div className={css.cardTitle}>
                                Choice Match
                            </div>

                            <div className={css.planDescription}>
                                <p><strong><FormattedMessage id="MembershipPlansPage.sitter.choiceBestFor" /></strong></p>
                                <p><FormattedMessage id="MembershipPlansPage.sitter.choiceYouGet" /></p>
                                <p><FormattedMessage id="MembershipPlansPage.sitter.choicePerks" /></p>
                            </div>

                            <div>
                                <div className={coupon ? css.cardPriceDiscounted : css.cardPrice}>
                                    <span className={css.price}>
                                        {choiceSubscriptionFormattedPrice}
                                    </span>
                                    per year
                                </div>
                                {coupon &&
                                    <div className={css.cardPrice}>
                                        <span className={css.price}>
                                            {choiceSubscriptionFormattedPriceWithCoupon}
                                        </span>
                                        per first year
                                    </div>
                                }
                            </div>

                            <div className={css.button}
                                onClick={() => createSubscription(choiceSubscription.id)}>
                                Continue with Choice
                                <img className={css.icon} src={ContinueIcon} />
                            </div>
                        </div>

                        {/* Premium Plan */}
                        <div className={css.card}>
                            <div className={css.cardTitle}>
                                Premium Match
                            </div>

                            <div className={css.planDescription}>
                                <p><strong><FormattedMessage id="MembershipPlansPage.sitter.premiumBestFor" /></strong></p>
                                <p><FormattedMessage id="MembershipPlansPage.sitter.premiumYouGet" /></p>
                                <p><FormattedMessage id="MembershipPlansPage.sitter.premiumPerks" /></p>
                            </div>

                            <div>
                                <div className={coupon ? css.cardPriceDiscounted : css.cardPrice}>
                                    <span className={css.price}>
                                        {premiumSubscriptionFormattedPrice}
                                    </span>
                                    per year
                                </div>
                                {coupon &&
                                    <div className={css.cardPrice}>
                                        <span className={css.price}>
                                            {premiumSubscriptionFormattedPriceWithCoupon}
                                        </span>
                                        per first year
                                    </div>
                                }
                            </div>

                            <div className={css.button}
                                onClick={() => createSubscription(premiumSubscription.id)}>
                                Continue with Premium
                                <img className={css.icon} src={ContinueIcon} />
                            </div>
                        </div>
                    </div>


                    <SectionCoupon
                        intl={intl}
                        coupon={coupon}
                        couponError={couponError}
                        handleChange={handleChange}
                        promoCode={promoCode}
                        isBusy={isBusy}
                        onApplyCoupon={onApplyCoupon}
                    />
                </div>

                {/* Included in Every Plan Section */}
                <div className={css.includedSection}>
                    <h2 className={css.includedTitle}>
                        <FormattedMessage id="MembershipPlansPage.sitter.includedTitle" />
                    </h2>
                    <p className={css.includedSubtitle}>
                        <FormattedMessage id="MembershipPlansPage.sitter.includedSubtitle" />
                        <NamedLink name="SearchHouseSitPage" className={css.helperLink}>
                            <FormattedMessage id="MembershipPlansPage.sitter.findAndConfirm" />
                        </NamedLink>
                    </p>

                    <ul className={css.includedList}>
                        <li>
                            <div className={css.featureIcon}>🏠︎🐾︎</div>
                            <FormattedMessage id="MembershipPlansPage.sitter.includedFeature1" />
                        </li>
                        <li>
                            <div className={css.featureIcon}>🔒︎💬︎</div>
                            <FormattedMessage id="MembershipPlansPage.sitter.includedFeature2" /></li>
                        <li>
                            <div className={css.featureIcon}>📹︎💻︎</div>
                            <FormattedMessage id="MembershipPlansPage.sitter.includedFeature3" />
                        </li>
                        <li>
                            <div className={css.featureIcon}>⭐︎📝︎</div>
                            <FormattedMessage id="MembershipPlansPage.sitter.includedFeature5" />
                        </li>
                    </ul>
                </div>

                {/* Trust Section */}
                <div className={css.trustSection}>
                    <h3 className={css.trustTitle}>
                        <FormattedMessage id="MembershipPlansPage.sitter.trustTitle" />
                    </h3>
                    <p className={css.trustSubtitle}>
                        <FormattedMessage id="MembershipPlansPage.sitter.trustSubtitle1" />
                        <NamedLink name="AboutHouseSitMatchPage" className={css.helperLink}>
                            <FormattedMessage id="MembershipPlansPage.sitter.trustSubtitle2" />
                        </NamedLink>
                        <FormattedMessage id="MembershipPlansPage.sitter.trustSubtitle3" />
                    </p>
                    {/* <a className={css.compareAnchorButton}
                        href="https://uk.trustpilot.com/review/housesitmatch.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FormattedMessage id="MembershipPlansPage.sitter.trustButtonText" />
                    </a> */}
                    <TrustWidgetBig />
                </div>

                {/* FAQs Section */}
                <div className={css.faqSection}>
                    <h2 className={css.faqTitle}>
                        <FormattedMessage id="MembershipPlansPage.sitter.faqTitle" />
                    </h2>

                    <div className={css.faqList}>
                        <CollapseFAQ list={faqs} />
                    </div>

                    {/* <div className={css.faqList}>
                    <div className={css.faqItem}>
                        <h4 className={css.faqQuestion}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq1Question" />
                        </h4>
                        <p className={css.faqAnswer}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq1Answer" />
                        </p>
                    </div>

                    <div className={css.faqItem}>
                        <h4 className={css.faqQuestion}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq2Question" />
                        </h4>
                        <p className={css.faqAnswer}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq2Answer" />
                        </p>
                    </div>

                    <div className={css.faqItem}>
                        <h4 className={css.faqQuestion}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq3Question" />
                        </h4>
                        <p className={css.faqAnswer}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq3Answer" />
                        </p>
                    </div>

                    <div className={css.faqItem}>
                        <h4 className={css.faqQuestion}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq4Question" />
                        </h4>
                        <p className={css.faqAnswer}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq4Answer" />
                        </p>
                    </div>

                    <div className={css.faqItem}>
                        <h4 className={css.faqQuestion}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq5Question" />
                        </h4>
                        <p className={css.faqAnswer}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq5Answer" />
                        </p>
                    </div>

                    <div className={css.faqItem}>
                        <h4 className={css.faqQuestion}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq6Question" />
                        </h4>
                        <p className={css.faqAnswer}>
                            <FormattedMessage id="MembershipPlansPage.sitter.faq6Answer" />
                        </p>
                    </div>
                </div> */}
                </div>
            </div>
        </div>
    );
};

export default SitterPlans;